import type { CalendarEventResponse } from "calendar/_schemas/calendar-event-schema";

/**
 * The dashboard's month calendar is a compact MUI date picker rather than the full calendar grid:
 * a day shows coloured dots for its events, and today is shaded whenever it has any.
 */
export const dashboardCalendarEmphasisColors = {
  todayWithEvents: "#eceff1",
  todayWithEventsHover: "#cfd8dc",
} as const;

export const dashboardCalendarMaxVisibleEventDots = 3;

export function getDashboardCalendarDayPresentation(eventCount: number, isToday: boolean, isPast: boolean) {
  const hasEvents = eventCount > 0;
  return {
    hasEvents,
    shadeEntireDay: isToday,
    showEventDots: hasEvents && !isToday && !isPast,
  };
}

export function getDashboardEventDotPresentation(eventCount: number) {
  return {
    visibleDotCount: Math.min(eventCount, dashboardCalendarMaxVisibleEventDots),
    showOverflow: eventCount > dashboardCalendarMaxVisibleEventDots,
  };
}

export function selectDashboardCalendarEvent(
  events: CalendarEventResponse[],
): CalendarEventResponse | undefined {
  return events.toSorted((left, right) => {
    if (left.isAllDay !== right.isAllDay) return left.isAllDay ? -1 : 1;
    if (!left.isAllDay) {
      const startDifference = new Date(String(left.start)).getTime() - new Date(String(right.start)).getTime();
      if (startDifference !== 0) return startDifference;
    }
    const creationDifference = new Date(left.createdDate).getTime() - new Date(right.createdDate).getTime();
    return creationDifference || left.id.localeCompare(right.id);
  })[0];
}
